import React from 'react';
import DOMPurify from 'dompurify';
import { useLocation } from 'react-router-dom';
import './ChatStreamResponseFormatting.scss';
import { markdownToHtml, markdownToHtmlForMarketReports } from "../../../utils/commonUtils";

// Define the props type for the component
interface DynamicTextRendererProps {
    text: string;
    isMarketReports?: boolean;
  }
  
const DynamicTextRenderer: React.FC<DynamicTextRendererProps> = ({ text, isMarketReports = false }) => { 
  const { pathname } = useLocation();

  const isMarketReportFormat = 
    isMarketReports || 
    pathname.includes('/sectorChatPage') || 
    pathname.includes('/kcChatPage');

    const convertMarkdown = isMarketReportFormat ? markdownToHtmlForMarketReports : markdownToHtml;
   
    return (
        <React.Fragment >
            <div className="custom-list" dangerouslySetInnerHTML={{ __html: convertMarkdown(DOMPurify.sanitize(text || '')) }} />
        </React.Fragment>
    );
  };


export default DynamicTextRenderer;
